document.addEventListener("DOMContentLoaded", function () {
    const input = document.querySelector('[js-nutritional-input]');
    const nutritionalItems = document.querySelectorAll('[data-nutritional-value]');
    const openButtons = document.querySelectorAll('[js-open-model]'); // updated
    const closeButton = document.querySelector('[js-close-popup-icon]');
    const popupOverlay = document.querySelector('[js-article-content-overlay]');
    const popupBox = document.querySelector('[js-article-content-popup]');

    let lastValidValue = parseFloat(input.value);

    nutritionalItems.forEach(item => {
        const fullText = item.textContent.trim();
        const numberMatch = fullText.match(/[\d.]+/);
        const unitMatch = fullText.replace(/[\d.\s]/g, '');
        if (numberMatch) {
            item.dataset.baseValue = parseFloat(numberMatch[0]);
            item.dataset.unit = unitMatch;
        }
    });

    function updateNutritionalValues(servings) {
        nutritionalItems.forEach(item => {
            if (item.dataset.fixed === "true") return;

            const base = parseFloat(item.dataset.baseValue);
            const unit = item.dataset.unit || '';
            if (!isNaN(base)) {
                let result;
                if (servings > 1) {
                    result = base * servings;
                } else {
                    let temp = base;
                    let fraction = servings;
                    while (fraction < 1) {
                        temp = temp / 2;
                        fraction *= 2;
                    }
                    result = temp;
                }
                item.textContent = `${Math.round(result)} ${unit}`;
            }
        });
    }

    input.addEventListener('input', () => {
        const currentValue = parseFloat(input.value);
        if (!isNaN(currentValue) && currentValue >= 1 && currentValue <= 100) {
            lastValidValue = currentValue;
            updateNutritionalValues(currentValue);
        } else if (input.value !== '') {
            input.value = lastValidValue;
        }
    });

    document.addEventListener('click', function (e) {
        const button = e.target.closest('[js-ingredient-button]');
        if (button) {
            let currentValue = parseFloat(input.value) || 1;
            if (currentValue < 100) {
                currentValue += 1;
                input.value = currentValue;
                lastValidValue = currentValue;
                updateNutritionalValues(currentValue);
            }
        }
    });

    updateNutritionalValues(lastValidValue);

    // Fix for multiple open buttons
    if (popupOverlay && popupBox) {
        openButtons.forEach(openButton => {
            openButton.addEventListener('click', function () {
                popupOverlay.classList.add('is-open');
                popupBox.classList.add('is-open');
            });
        });
    }

    if (closeButton && popupOverlay && popupBox) {
        closeButton.addEventListener('click', function () {
            popupOverlay.classList.remove('is-open');
            popupBox.classList.remove('is-open');
        });

        popupOverlay.addEventListener('click', function () {
            popupOverlay.classList.remove('is-open');
            popupBox.classList.remove('is-open');
        });
    }
});

document.addEventListener('click', function (e) {
    const shareBtn = e.target.closest('[js-ingredient-share-button]');
    if (shareBtn) {
        const url = window.location.href;
        navigator.clipboard.writeText(url).then(() => {
            const originalText = shareBtn.textContent;
            shareBtn.textContent = 'kopiert!';
            shareBtn.classList.add('copied');
            setTimeout(() => {
                shareBtn.textContent = originalText;
                shareBtn.classList.remove('copied');
            }, 2000);
        });
    }
});

const printBtn = document.querySelector("[js-print-btn]");
printBtn?.addEventListener("click", function(event) {
    event.preventDefault();
    window.print();
});
